import { useCallback } from "react";

import { useQuery } from "hooks";
import { useFeatures } from "components/FeatureFlag";

import { getAdvisors, getAssignees } from "./query";

export function useAssignees(legacyFetch, withCrmUser = false) {
  const { enabled: addUserFFEnabled = false } = useFeatures(
    "add-user-from-user-selector"
  );
  const serviceTeamFFEnabled = useFeatures("service-team-settings");

  const getQuery = useCallback(() => {
    if (addUserFFEnabled) return getAssignees({ withCrmUser });
    if (serviceTeamFFEnabled) return getAssignees();

    return getAdvisors();
  }, [addUserFFEnabled, serviceTeamFFEnabled, withCrmUser]);

  const { loading, data, reloadData, clearCache } = useQuery(getQuery, {
    options: { fetchOnInit: false, overrideFetch: legacyFetch, cached: true },
  });

  return [reloadData, loading, data, clearCache];
}

export default useAssignees;
